import { render, staticRenderFns } from "./CommsPageMobile.vue?vue&type=template&id=0c78d574&scoped=true&"
import script from "./CommsPageMobile.vue?vue&type=script&lang=js&"
export * from "./CommsPageMobile.vue?vue&type=script&lang=js&"
import style0 from "./CommsPageMobile.vue?vue&type=style&index=0&id=0c78d574&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c78d574",
  null
  
)

export default component.exports